import { MarginRtoDate } from '../../models/margin-rto-date.model';

export interface MarginRtoDatesSlice {
    readonly rtoDates: MarginRtoDate[];
}

export const initialMarginRtoDatesSlice: MarginRtoDatesSlice = {
    rtoDates: []
};
